
import React, { useEffect, useState } from 'react';
import PrimaryCdTable from './tables/PrimaryCdTable';
import { styled } from 'styled-components';
import { DatePicker, Select } from 'antd';
import FormActionButton from '../ui/FormActionButton';
import Title from '../ui/Title';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const PrimaryCD = () => {
    const [startDate, setStartDate] = useState({
        dateValue: '',
        dateString: '',
    });
    const [endDate, setEndDate] = useState({
        dateValue: '',
        dateString: '',
    });
    const [dataSource, setDataSource] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchPrimaryCDdata();
    }, []);

    const submitHandler = async (e) => {
        e.preventDefault();
        // const queryStrings = ``;
        fetchPrimaryCDdata();
    }

    const fetchPrimaryCDdata = async() => {
        setIsLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/transaction/list?start_date=${startDate.dateString}&end_date=${endDate.dateString}`, {
                method: 'GET',
                headers: { 'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`) }
            });
            const responseData = await response.json();
            console.log(responseData);
            if (responseData.code === 200) {
                console.log(responseData.data.map((item) => ({
                    ...item,
                    key: item.Id
                })))
                setDataSource(responseData.data.map((item) => ({
                    ...item,
                    key: item.Id
                })));
            } else {
                setDataSource([]);
            }
        } catch (e) {
            setIsError(true);
            setIsLoading(false);
        }
        setIsLoading(false);
    }

    const resetHandler = () => {
        setStartDate('');
        setEndDate('');
    }

    return (
        <Wrapper>
            <section className='form-section'>
                <Title>Primary CD</Title>
                <form onSubmit={submitHandler}>
                    <div className='control'>
                        <label>Start Date:</label>
                            <DatePicker 
                                onChange={(date, dateString) => setStartDate({dateValue: date, dateString: dateString})} 
                                value={startDate.dateValue}
                                size='large' 
                                style={{width: '100%', borderRadius: '0.2rem'}} 
                            />
                        </div>
                    <div className='control'>
                        <label>End Date:</label>
                            <DatePicker 
                                onChange={(date, dateString) => setEndDate({dateValue: date, dateString: dateString})} 
                                value={endDate.dateValue}
                                size='large' 
                                style={{width: '100%', borderRadius: '0.2rem'}} 
                            />
                    </div>
                    <div className='action-control'>
                        <FormActionButton type='submit' bg='#10ac84'>
                            Submit 
                        </FormActionButton>
                    </div>
                </form>
            </section>
            <PrimaryCdTable dataSource={dataSource} isError={isError} isLoading={isLoading} />
        </Wrapper>
    );
}

export default PrimaryCD;

const Wrapper = styled.div`
    width: 95%;
    margin: auto;
    margin-top: 2rem;
    .form-section {
        padding: 0rem 2rem 1rem 2rem;
        border: 1px solid #F0F0F0;
        border-radius: 0.5rem;
        margin-bottom: 2rem;
    }
    form {
        margin-top: 2rem;
        margin-bottom: 1rem;
        display: flex;
        justify-content: space-between;
        gap: 2rem;
    }
    .control {
        flex: 1;
        max-width: 40rem;
        display: flex;
        align-items: center;
        margin-bottom: 3rem;
    }
    .control label {
        width: 30%;
        font-weight: bold;
        font-size: 1.5rem;
        letter-spacing: 0.0625rem;
        color: #36454F;
    }
    .action-control {
    }
    .ant-input {
        border-radius: 0.2rem;
    }
    .ant-input:focus {
        border-color: ${({theme}) => theme.colors.primary};
    }
`;
